module.exports = __webpack_public_path__ + "static/media/person.9ef9acfc.jpg";